import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const aiApi = axios.create({
  baseURL: process.env.REACT_APP_AI_URL || 'http://localhost:8000',
});

// WebSocket: para URLs relativas (/ai), monta ws(s)://host a partir da página;
// para URLs http(s) absolutas, converte o protocolo como antes.
export const AI_WS_URL = (() => {
  const base = process.env.REACT_APP_AI_URL || 'http://localhost:8000';
  if (/^https?:\/\//.test(base)) return base.replace(/^http/, 'ws');
  const wsProto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${wsProto}//${window.location.host}${base}`;
})();

export default api;
